function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super();
    this.isLoaded = false;
  }

  connectedCallback() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(this.loadProducts.bind(this), { timeout: 1500 });
    } else {
      this.loadProducts();
    }
  }

  getSearchQueryString() {
    const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-variants") || "[]"));
    const searchTerms = [];
    
    // Parse the stored JSON strings back into objects
    for (const item of items) {
      const parsedItem = JSON.parse(item);
      
      // Skip if we're excluding this product
      if (this.hasAttribute("exclude-id") && parsedItem.productId === parseInt(this.getAttribute("exclude-id"))) {
        continue;
      }
      
      searchTerms.push(`id:${parsedItem.productId}`);
      
      // Break once we hit our desired product count
      if (searchTerms.length >= parseInt(this.getAttribute("products-count"))) {
        break;
      }
    }
    
    return searchTerms.join(" OR ");
  }

  async loadProducts() {
    if (this.isLoaded) {
      return;
    }
    
    this.isLoaded = true;
    const section = this.closest(".shopify-section");
    const url = `${Shopify.routes.root}search?type=product&q=${this.getSearchQueryString()}&section_id=${extractSectionId(section)}`;
    
    try {
      const response = await fetch(url, { priority: "low" });
      const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html");
      const recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
      
      if (recentlyViewedProductsElement.childElementCount > 0) {
        // Get the stored variant data to pass to the template
        const storedItems = JSON.parse(localStorage.getItem("theme:recently-viewed-variants") || "[]")
          .map(item => JSON.parse(item));
        
        // Add variant data as a data attribute
        recentlyViewedProductsElement.setAttribute('data-variants', JSON.stringify(storedItems));
        
        this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
        
        // Update variant images after content is rendered
        this.updateVariantOutput(storedItems);

        // Remove hidden attribute if there are products
        if (storedItems.length > 1) {
          this.removeAttribute('hidden');
        }
      } else {
        section.remove();
      }
    } catch (e) {
      console.error('Error loading recently viewed products:', e);
      section.remove();
    }
  }

  updateVariantOutput(storedItems) {
    const productItems = this.querySelectorAll('.shop-grid-item-v2');
    
    const productVariantMap = new Map();
    storedItems.forEach(item => {
        const productId = item.productId;
        if (!productVariantMap.has(productId)) {
            productVariantMap.set(productId, []);
        }
        productVariantMap.get(productId).push(item);
    });

    productItems.forEach(item => {
        const productId = parseInt(item.dataset.productId);
        const variantData = productVariantMap.get(productId);
        
        if (variantData && variantData.length > 0) {
            const variant = variantData.shift();
            
            // Update links
            const links = item.querySelectorAll('a');
            links.forEach(link => {
                const currentUrl = new URL(link.href, window.location.origin);
                currentUrl.searchParams.set('variant', variant.variantId);
                link.href = currentUrl.pathname + currentUrl.search;
            });
            
            // Update image
            const imageElement = item.querySelector('a.shop-grid-item-image img');
            if (imageElement && variant.variantImage) {
                imageElement.src = variant.variantImage;
            }

            // Update color title
            const titleElement = item.querySelector('.product-color');
            if (titleElement && variant.title) {
                titleElement.textContent = variant.title;
            }

            // Update price
            const priceElement = item.querySelector('span.money');
            if (priceElement && variant.variantPrice) {
                priceElement.textContent = variant.variantPrice;
            }
        }
    });
}
}

if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}